import React, { useState } from "react";
import {
  preUploadAdminFile,
  sampleUploadAdminFile,
} from "../../../services/met/Service";

const BulkAddMemberManagement = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResponse(null);
    setError("");
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      setError("");
      const res = await preUploadAdminFile(formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("res: ", res);
      setResponse(res.data);
    } catch (err) {
      console.error(err);
      setError("Upload failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const downloadSample = async () => {
    try {
      const res = await sampleUploadAdminFile();

      const blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8;",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "admin_sample.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  return (
    <div className="tw-w-full">
      <div className="tw-border tw-rounded-xl tw-p-6 tw-w-full">
        <h2 className="tw-text-xl tw-font-bold tw-text-gray-800 tw-mb-4">
          Admin Bulk Upload
        </h2>

        <button
          onClick={downloadSample}
          className="tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg tw-mb-4"
        >
          Download Sample File
        </button>

        <div className="tw-mb-4">
          <input
            type="file"
            accept=".csv,.xlsx"
            onChange={handleFileChange}
            className="tw-w-full tw-border tw-border-gray-300 tw-rounded-lg tw-p-2"
          />
        </div>

        <button
          onClick={handleUpload}
          disabled={loading}
          className={`tw-w-full tw-py-2 tw-rounded-lg tw-text-white ${
            loading ? "tw-bg-gray-400" : "tw-bg-green-500 hover:tw-bg-green-600"
          }`}
        >
          {loading ? "Uploading..." : "Upload File"}
        </button>

        {error && (
          <div className="tw-mt-4 tw-text-red-500 tw-text-sm">{error}</div>
        )}

        {response && (
          <div className="tw-mt-6 tw-bg-gray-50 tw-p-4 tw-rounded-lg tw-border">
            <h3 className="tw-text-lg tw-font-semibold tw-mb-2">
              Upload Result
            </h3>

            <pre className="tw-text-xs tw-bg-black tw-text-green-400 tw-p-2 tw-rounded tw-overflow-auto">
              {JSON.stringify(response, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkAddMemberManagement;
